var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "#00D180",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16882_1277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58341 8.375H6.20841V14.875H4.58341C4.43976 14.875 4.30198 14.8179 4.2004 14.7163C4.09882 14.6148 4.04175 14.477 4.04175 14.3333V8.91667C4.04175 8.77301 4.09882 8.63523 4.2004 8.53365C4.30198 8.43207 4.43976 8.375 4.58341 8.375ZM7.45046 7.67462L10.9171 4.20796C10.9632 4.16175 11.0244 4.13373 11.0895 4.12905C11.1546 4.12438 11.2192 4.14336 11.2714 4.1825L11.7334 4.52917C11.8617 4.6255 11.9587 4.75767 12.012 4.90901C12.0653 5.06036 12.0726 5.22409 12.033 5.37958L11.4084 7.83333H14.8751C15.1624 7.83333 15.4379 7.94747 15.6411 8.15063C15.8443 8.3538 15.9584 8.62935 15.9584 8.91667V10.0563C15.9586 10.1979 15.931 10.3381 15.8772 10.4691L14.2007 14.5397C14.1598 14.639 14.0904 14.7238 14.0011 14.7835C13.9119 14.8432 13.807 14.875 13.6997 14.875H7.83341C7.68976 14.875 7.55198 14.8179 7.4504 14.7163C7.34882 14.6148 7.29175 14.477 7.29175 14.3333V8.05758C7.29178 7.91394 7.34887 7.77618 7.45046 7.67462Z",
    fill: "#00D180"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16882_1277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(3.5 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertLow);
export default __webpack_public_path__ + "static/media/alert-low.29f6f955bdc9b21bd5e2525cf7246c2c.svg";
export { ForwardRef as ReactComponent };